import { ReactNodeViewRenderer as d } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { BLOCK_IMAGE_STYLES as T, FIGCAPTION_STYLES as b, FIGURE_CENTERED_STYLES as A, getFigureRightStyles as h, FIGURE_MOBILE_FULL_WIDTH_STYLES as C } from "../../constants/default-styles.mjs";
import { ImageNameEnum as _, ImageModeEnum as n } from "./image-enum.mjs";
import { convertStyleObjectToCss as g } from "../../utils/style-helpers.mjs";
import { CustomImage as R } from "./custom-image.mjs";
import { Image as k } from "./image.mjs";
import { getContainerWidthFromElement as B } from "./utils/get-container-width-from-element.mjs";
import { getImageAttrs as F } from "./utils/get-image-attrs.mjs";
import { getImageWithLinkHtml as M } from "./utils/get-image-with-link-html.mjs";
import { mergeAttributes as w } from "../../node_modules/@tiptap/core/dist/index.mjs";
const $ = k.extend({
  name: _.Block,
  addNodeView() {
    return d(R);
  },
  parseHTML() {
    return [
      {
        // skip ckeditor's legacy - tables https://app.shortcut.com/systeme/story/53281/he-has-a-problem-with-one-of-his-campaigns-in-the-classic-editor-where-he-can-no-longer-find-the-content-of-his-emails
        tag: "figure:not(.table)",
        getAttrs: (t) => {
          const m = t.querySelector("img"), o = t.querySelector("a"), r = t.querySelector("figcaption"), a = o == null ? void 0 : o.getAttribute("href"), c = F(m), s = B(t), i = t.hasAttribute("is-mobile-full-width");
          return {
            imageMode: t != null && t.style.float ? n.BlockRight : n.BlockCenter,
            href: a,
            containerWidth: s,
            caption: r == null ? void 0 : r.textContent,
            isMobileFullWidth: i,
            ...c
          };
        }
      }
    ];
  },
  renderHTML({
    HTMLAttributes: {
      caption: t,
      href: m,
      imageMode: o,
      alt: r,
      src: a,
      title: c,
      width: s,
      height: i,
      containerWidth: e,
      uploadingProps: S,
      isMobileFullWidth: f
    }
  }) {
    if (S) return ["span", { style: "display: none;" }];
    const l = { ...T };
    s && i && (l.aspectRatio = `${s}/${i}`), e !== "auto" && (l.width = e);
    const I = w({
      src: a,
      alt: r,
      title: c,
      width: s,
      style: g(l)
    }), u = [M(I, { href: m })];
    t && u.push([
      "figcaption",
      {
        style: g(b)
      },
      t
    ]);
    const L = o === n.BlockCenter ? {
      ...A,
      ...e && { width: e }
    } : {
      ...h(!1),
      ...e && { width: e }
    }, p = {
      style: g(L)
    };
    f && (p["is-mobile-full-width"] = "true");
    const y = ["figure", p, ...u];
    return f ? [
      "div",
      { class: "is-mobile-full-width" },
      ["head", {}, ["style", { type: "text/css" }, C]],
      y
    ] : y;
  }
});
export {
  $ as BlockImage
};
